import React from "react";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import moment from "moment-timezone";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import { Row, Col } from "react-bootstrap";
import { showError, showSuccess } from "ReduxErrorBar";
import DayPicker, { DateUtils } from "react-day-picker";
import { BaseComponent } from "BaseComponent";
import {
  dateRangeUpdate,
  patchEventDetails,
  updateDateProps,
} from "GeneralTabAction";
import { updateUnsavedChanges } from "DashboardMenuAction";
import { fetchUserInterests, openInterestModal } from "ActionsMessage";
import {
  DATE_FORMAT,
  DISPLAY_LOCAL_DATE_FORMAT,
  DEVELOPMENT_TYPE,
  maxLengthObjectFc,
} from "Constants";
import TimeZoneSelect from "./timezone-select.js";
import DateBlock from "./date-block.js";
import LocaleStrings from "Languages";
import InterestTag from "../../content/components/messages/interest-tag";
import AddInterests from "../../content/components/messages/addinterests";

var MAXLENOBJ = {};
class EditEventnew extends BaseComponent {
  constructor(props) {
    super(props);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDataChange = this.handleEndDataChange.bind(this);

    this.state = {
      showPicker: false,
      loading: false,
      dateError: "",
      hoverRange: undefined,
      timezone: props.timezone,
    };

    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleDayMouseEnter = this.handleDayMouseEnter.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
  }

  componentDidMount() {
    this.props.fetchUserInterests(this.props.session);
    MAXLENOBJ = maxLengthObjectFc(this.props.history);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.timezone !== this.props.timezone) {
      this.setState({ timezone: nextProps.timezone });
    }
  }

  addInterest = () => {
    this.props.openInterestModal(true);
  };

  renderTags = () => {
    return this.props.interestData.map((tag, index) => (
      <InterestTag key={index} tag={tag} />
    ));
  };

  submitSettings() {
    // debugger;

    //Adding extra validation for date
    if (this.props.dateProps.from && this.props.dateProps.to)
      this.props.dispatch(submit("EditEventForm"));
    else {
      var errorMessage = "";
      if (!this.props.dateProps.from) {
        errorMessage = "Event start date is required";
      } else if (!this.props.dateProps.to) {
        errorMessage = "Event end date is required";
      }

      this.setState({ dateError: errorMessage });

      this.props.dispatch(setSubmitFailed("EditEventForm", "eventenddate"));
      this.props.dispatch(stopSubmit("EditEventForm", new Error(errorMessage)));

      setTimeout(() => {
        this.setState({ dateError: "" });
      }, 2000);
    }
    //this.props.handleSubmit();
  }

  isSelectingFirstDay(from, to, day) {
    const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
    const isRangeSelected = from && to;
    return !from || isBeforeFirstDay || isRangeSelected;
  }

  handleDayClick(day) {
    //debugger;
    this.props.updateUnsavedChanges();

    const { from, to } = this.props.dateProps;
    /*if (from && to && day >= from && day <= to) {
      this.handleResetClick();
      return;
    }*/

    if (this.isSelectingFirstDay(from, to, day)) {
      if (day < new Date()) return;
      /*this.setState({
        from: day,
        to: null,
        enteredTo: null,
      });*/

      this.props.updateDateProps({
        ...this.props.dateProps,
        from: day,
        to: null,
        enteredTo: null,
      });
      this.props.change("eventstartdate", moment(day).format(DATE_FORMAT));
      this.props.change("eventenddate", "");

      /*var hoverRange=[];
      for (var i=1; i <= 6; i++ ) {
        var hoverDate=new Date(day);
        hoverDate.setDate(hoverDate.getDate()+1);
        hoverRange.push(hoverDate);
      }*/
      var hoverRangeEndDate = new Date(day);
      hoverRangeEndDate.setDate(hoverRangeEndDate.getDate() + 29);

      this.setState({ hoverRange: { from: day, to: hoverRangeEndDate } });
    } else {
      // debugger;
      /*this.setState({
        to: day,
        enteredTo: day,
      });*/
      var curDate = moment(day);
      var disableDate = moment(from).add(29, "days");

      if (curDate.isAfter(disableDate, "day")) {
        return;
      }
      this.props.updateDateProps({
        ...this.props.dateProps,
        to: day,
        enteredTo: day,
      });
      this.props.dateRangeUpdate({
        startDate: from,
        endDate: day,
        allDate: {},
      });

      this.props.change("eventstartdate", moment(from).format(DATE_FORMAT));
      this.props.change("eventenddate", moment(day).format(DATE_FORMAT));

      this.setState({ showPicker: false });
    }
  }

  handleDayMouseEnter(day) {
    const { from, to } = this.state;
    if (!this.isSelectingFirstDay(from, to, day)) {
      this.props.updateDateProps({ ...this.props.dateProps, enteredTo: day });
      /*this.setState({
        enteredTo: day,
      });*/
    }
  }

  handleResetClick() {
    this.props.updateDateProps({ from: null, to: null, enteredTo: null });
    //this.setState({from: null,to: null,enteredTo: null});
  }

  handleStartDateChange(date) {
    this.props.updateUnsavedChanges();
    this.props.dateRangeUpdate({ startDate: date, endDate: date, allDate: {} });
  }

  handleEndDataChange(date) {
    //debugger;
    this.props.updateUnsavedChanges();
    this.props.dateRangeUpdate({
      startDate: this.props.startDate,
      endDate: date,
      allDate: {},
    });
  }

  renderBlockList(startDate, endDate, allDate) {
    startDate = moment(startDate);
    endDate = moment(endDate);

    //Sorting date.
    allDate.sort(
      (a, b) =>
        new moment(a.scheduledate).format("YYYYMMDD") -
        new moment(b.scheduledate).format("YYYYMMDD")
    );

    var arr = [];
    var day = {};
    var n = endDate.diff(startDate, "days") + 1;
    for (var i = 1; i <= n; i++) {
      if (i !== 1) {
        day = moment(day).add(1, "days");
      } else {
        day = startDate;
      }
      var activeDate = _.find(allDate, {
        scheduledate: moment(day).format(DATE_FORMAT),
      });
      arr.push(<DateBlock key={i} day={day} activeDate={activeDate} />);
    }
    return arr;
  }

  onConvertedTimezoneChange() {
    this.props.updateUnsavedChanges();
  }

  toggleCalendar = () => {
    if (!this.state.showPicker) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }
    if (this.props.dateProps.to)
      this.setState((prevState) => ({
        showPicker: !prevState.showPicker,
      }));
    // this.setState({ showPicker: !this.state.showPicker });
  };

  handleOutsideClick = (e) => {
    if (!this.node.contains(e.target)) this.toggleCalendar();
  };

  updatetimezone = (value) => {
    if (typeof value !== "boolean") {
      this.props.autofill("eventtimezone", value);
      this.setState({ timezone: value });
      this.props.updateUnsavedChanges();
    }
  };

  render() {
    // debugger;
    var { handleSubmit, submit, interestModal, dateProps } = this.props;
    const { from, to, enteredTo } = dateProps;
    var allDate = this.props.allDate;
    const { hoverRange } = this.state;
    const today = new Date();
    const modifiers = { start: from, end: enteredTo, highlighted: hoverRange };
    var disableDates = new Date(this.props.dateProps.from); //new Date(new Date(this.props.dateProps.from.getDate()+6););
    if (disableDates) disableDates.setDate(disableDates.getDate() + 6);

    // const disabledDays = { before: this.props.dateProps.from, after:disableDates};
    const selectedDays = [from, { from, to: enteredTo }];

    var endDateColor = "#2676ea";
    if (this.props.displayEndDate === "XX/XX/XXXX") {
      endDateColor = "#d43f3a";
    }

    var curTime = moment().tz(this.state.timezone);
    if (curTime) {
      curTime = curTime.format("h:mm A");
    }

    // console.log(interestModal);

    return (
      <div>
        <form
          ref={"editevent"}
          onSubmit={handleSubmit(submit)}
          encType="multipart/form-data"
        >
          <div className="general-tab-warp">
            <div
              className="control-label-top"
              style={{ paddingBottom: 10, paddingTop: 8, fontWeight: 500 }}
            >
              {LocaleStrings.general_form_time_section}
            </div>
            <div className="general-info">
              {DEVELOPMENT_TYPE === "eventify" ? (
                <div className="form-group row">
                  <label className="control-label-top col-sm-12">
                    {LocaleStrings.general_form_label_event_duration}
                    <span className="label-mandatory">*</span>
                  </label>
                  <div
                    className="col-sm-12"
                    ref={(node) => {
                      this.node = node;
                    }}
                  >
                    {this.state.showPicker ? (
                      <DayPicker
                        className="Range"
                        numberOfMonths={2}
                        // fromMonth={from}
                        month={from}
                        selectedDays={selectedDays}
                        modifiers={modifiers}
                        disabledDays={{ before: today }}
                        onDayClick={this.handleDayClick}
                        onDayMouseEnter={this.handleDayMouseEnter}
                      />
                    ) : null}

                    <Row>
                      <div
                        className={`${
                          !this.props.isPublished ? "col-md-10" : "col-md-12"
                        }`}
                      >
                        <div className="event-date-field-box">
                          <div>
                            <div>{this.props.displayStartDate}</div>
                            <Field
                              name="eventstartdate"
                              component={this.renderHiddenFieldText}
                            />
                          </div>
                          <div className="ml-10 mr-10">to</div>
                          <div className="end-specific-date">
                            <div>{this.props.displayEndDate}</div>
                            <Field
                              name="eventenddate"
                              component={this.renderHiddenFieldText}
                            />
                          </div>
                        </div>
                      </div>

                      {!this.props.isPublished ? (
                        <div className="col-md-2" style={{ marginTop: 5 }}>
                          <Col md={2}>
                            <Button
                              className={
                                this.state.showPicker
                                  ? "btn-custom-blue"
                                  : "btn-custom-blue"
                              }
                              style={{ marginTop: -5 }}
                              type="button"
                              onClick={this.toggleCalendar}
                            >
                              <i
                                className={
                                  this.state.showPicker
                                    ? "fa fa-times"
                                    : "fa fa-calendar"
                                }
                              ></i>
                            </Button>
                          </Col>
                        </div>
                      ) : (
                        ""
                      )}
                    </Row>

                    <div className="duration-info">
                      {this.state.dateError !== "" ? (
                        <span style={{ color: "#f26d7d" }}>
                          {this.state.dateError}
                        </span>
                      ) : (
                        <span className="custom-text2-secondary-normal">
                          *{" "}
                          {
                            LocaleStrings.general_form_label_event_duration_notes
                          }
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {DEVELOPMENT_TYPE === "eventify" ? (
                <div className="form-group row">
                  <label className="control-label-top col-sm-12">
                    {LocaleStrings.general_form_label_event_day}
                  </label>
                  <div className="col-sm-12">
                    <ul className="event-days">
                      {this.renderBlockList(from, to, allDate)}
                    </ul>
                  </div>
                </div>
              ) : (
                ""
              )}

              {DEVELOPMENT_TYPE === "eventify" ? (
                <div className="row">
                  <div className="col-md-6">
                    <label className="control-label-top">
                      {LocaleStrings.general_form_label_event_timezone}
                    </label>
                    <div>
                      <Field
                        name="eventtimezone"
                        component={this.renderHiddenFieldText}
                      />
                      <div>
                        <TimeZoneSelect
                          defaultTimezone={this.state.timezone}
                          timezonecallback={this.updatetimezone}
                        />
                      </div>
                    </div>
                    <div className="currenttime custom-text2-secondary-normal">
                      {`${LocaleStrings.general_form_label_event_timezone_time_message} ${curTime}`}
                    </div>
                  </div>

                  {/* Global Timezone Uncommented For Dev On 03/03/22 */}
                  <div className="col-md-6">
                    <div className="col-md-12 globaltimezone-section">
                      <label className="control-label-top">
                        {LocaleStrings.general_form_label_global_timezone}
                      </label>
                      <div className="col-md-12">
                        <span className="text-left">
                          <label className="m-0 switch-button-container">
                            <Field
                              name="showconvertedtimezone"
                              component="input"
                              type="checkbox"
                              onChange={this.onConvertedTimezoneChange.bind(
                                this
                              )}
                            />
                            <span className="switch-slider switch-round"></span>
                          </label>
                        </span>
                      </div>
                      <div className="custom-text2-secondary-normal pt-10">
                        {
                          LocaleStrings.general_form_label_event_converted_timezone_on_app
                        }
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>

            <div
              className="control-label-top"
              style={{ paddingBottom: 10, paddingTop: 13, fontWeight: 500 }}
            >
              {LocaleStrings.general_form_event_tags_section}
            </div>

            <div className="general-info">
              <div className="row">
                <div className="col-sm-8 col-lg-9">
                  <div>
                    <label className="control-label-top">
                      {LocaleStrings.general_form_event_tags_section}
                    </label>
                    <div className="custom-text2-secondary-normal">
                      {LocaleStrings.general_form_event_tags_subtext}
                    </div>
                    {/* <div className="interest-subtitle-info">{`Note - Maximum of ${MAX_INTEREST_COUNT} interests allowed to be added`}</div> */}
                  </div>
                </div>
                <div className="col-sm-4 col-lg-9" style={{ paddingTop: 12 }}>
                  <Button
                    type="button"
                    className="btn btn-custom-blue"
                    onClick={this.addInterest}
                  >
                    {LocaleStrings.button_manage_tags}
                  </Button>
                </div>
              </div>
              {/* <div className="row">
              <div className="col-md-8" ></div>
              <div className="col-md-4" >
                <div style={{display:'flex',  paddingRight: 16}}>
                  <div style={{fontWeight: 700, paddingTop: 8}}>Force Attendee Chat Invites</div> &nbsp;&nbsp;
                  <label className="poll-switch" style={{marginTop: 5}}>
                      <input type="checkbox" onChange={this.changeChatInvitesStatus} checked={checked}/>
                      <span className="poll-slider poll-round"></span>
                  </label>
                </div>
              </div>
            </div> */}
              {/* <div className="h-divider"></div> */}
              <div className="clearfix"></div>
              <div style={{ paddingTop: 15, paddingBottom: 4 }}>
                {this.renderTags()}
              </div>
            </div>
          </div>
        </form>

        {interestModal.status ? <AddInterests /> : ""}
      </div>
    );
  }
}
function mapStateToProps(state) {
  var eventData = state.eventData[0];
  var isPublished = false;
  var today = moment().format("YYYY-MM-DD");

  if (eventData) {
    // isPublished = eventData.published;
    isPublished = moment(eventData.eventenddate).isSameOrBefore(today); // Now we are allowing admin to change event date before event end date. This code is updated by vinay on 23/08/2021

    // if(eventData.policylisting == 1) {
    //   eventData.policylisting = "1";
    // }
    // else {
    //   eventData.policylisting = "0";
    // }
  }

  var startDate = moment().add(1, "days");
  if (eventData && eventData.eventstartdate)
    startDate = eventData.eventstartdate;

  var endDate = moment().add(6, "days");
  if (eventData && eventData.eventenddate) endDate = eventData.eventenddate;

  var displayStartDate =
    state.dateProps && state.dateProps.from
      ? moment(state.dateProps.from).format(DISPLAY_LOCAL_DATE_FORMAT)
      : "XX/XX/XXXX";
  var displayEndDate = "XX/XX/XXXX";
  if (state.dateProps.to)
    displayEndDate = moment(state.dateProps.to).format(
      DISPLAY_LOCAL_DATE_FORMAT
    );

  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  var timezone = null;
  if (eventData && eventData.eventtimezone) timezone = eventData.eventtimezone;

  if (!timezone) {
    eventData = { ...eventData, eventtimezone: tz };
    timezone = tz;
  }
  var interestData = [];
  if (state.interests) {
    state.interests.map((interest, index) => {
      var interestObj = { ...interest, value: interest.interest };
      interestData.push(interestObj);
    });
  }

  return {
    session: state.session,
    initialValues: eventData,
    scheduledates: state.scheduledates,
    allDate: state.updateScheduleDates,
    startDate,
    endDate,
    dateProps: state.dateProps,
    displayStartDate,
    displayEndDate,
    isPublished,
    timezone,
    interestData,
    interestModal: state.interestModal,
  };
}

function validate(values) {
  var errors = {};
  if (
    (values["eventname"] && values["eventname"].trim() === "") ||
    values["eventname"] === ""
  ) {
    errors["eventname"] = LocaleStrings.general_form_label_event_name_error1;
  }
  if (
    (values["country"] && values["country"].trim() === "") ||
    values["country"] === ""
  ) {
    errors["country"] = LocaleStrings.general_form_label_event_venue_error1;
  }

  if (values["eventname"] && MAXLENOBJ) {
    if (values["eventname"].length > MAXLENOBJ.eventname) {
      errors["eventname"] = "Max character length is: " + MAXLENOBJ.eventname;
    }
  }

  if (values["eventdescription"] && MAXLENOBJ) {
    if (values["eventdescription"].length > MAXLENOBJ.eventdescription) {
      errors["eventdescription"] =
        "Max character length is: " + MAXLENOBJ.eventdescription;
    }
  }

  if (values["country"] && MAXLENOBJ) {
    if (values["country"].length > MAXLENOBJ.country) {
      errors["country"] = "Max character length is: " + MAXLENOBJ.country;
    }
  }

  return errors;
}

function onFormSubmit(values, dispatch, props) {
  var {
    eventname,
    country,
    eventdescription,
    eventid,
    eventstartdate,
    eventenddate,
    eventtype,
    eventtimezone,
    showconvertedtimezone,
    policylisting,
    published,
  } = values;
  values = {
    eventname,
    country,
    eventdescription,
    eventid,
    eventstartdate,
    eventenddate,
    eventtype,
    eventtimezone,
    showconvertedtimezone,
    policylisting,
    published,
    allDate: props.allDate,
  };
  props.submitSettingsHandler(values);
}

export default connect(
  mapStateToProps,
  {
    updateUnsavedChanges,
    updateDateProps,
    dateRangeUpdate,
    patchEventDetails,
    showError,
    showSuccess,
    fetchUserInterests,
    openInterestModal,
  },
  null,
  { forwardRef: true }
)(
  reduxForm({
    validate,
    form: "EditEventForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    onSubmit: onFormSubmit,
  })(EditEventnew)
);
